// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"354":"2a0c94bd","411":"164ba63e"}[chunkId] + ".chunk.css";
};